<template>
    <div>
        <div class="d-flex px-4">
            <eod-btn v-if="!hideAdd" class="ml-auto" mdi-icon="mdi-plus" label="Nieuw item" small @click="showCreateTodoDialog"></eod-btn>
        </div>
        <v-list dense v-if="items && items.length > 0" two-lines :key="updateList">
            <v-list-item v-for="(todo, todoIndex) in items" :key="todoIndex" @click="toggleStatus(todoIndex)" :disabled="isChangeStatusLoading">
                <v-list-item-action v-if="!hideCheckbox">
                    <v-checkbox :input-value="todo.statusCode" value="done"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ todo.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{todo.responsibleGroup.name}}<span v-if="todo.description"> | {{todo.description}}</span></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="!hideEdit || !hideDelete">
                    <div class="d-flex">
                    <v-btn v-if="!hideEdit" @click="showEditTodoDialog(todoIndex)" icon small><v-icon small>mdi-pencil-outline</v-icon></v-btn>
                    <v-btn v-if="!hideDelete" @click="showDeleteTodoDialog(todoIndex)" icon small color="error"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                    </div>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <div v-else class="px-4 py-4">
            <v-alert dense text class="mt-2 mb-0 grey--text">Er zijn nog geen items gekoppeld.</v-alert>
        </div>
        <eod-delete-dialog v-if="todoToDeleteIndex != null" :loading="isDeleteLoading" v-model="isDeleteTodoDialogVisible" :item="items[todoToDeleteIndex]" @delete="deleteTodo"></eod-delete-dialog>
        <eod-dialog v-if="isCreateTodoDialogVisible" :loading="isCreateLoading" v-model="isCreateTodoDialogVisible" :title="'Item '+ (newTodo.id?'aanpassen':'aanmaken')" icon="mdi-plus" iconColor="primary" :okText="(newTodo.id?'Opslaan':'Toevoegen')" @okAction="addTodo">
            <v-form ref="createTodoForm">
                <eod-text-field hide-details :rules="[val => $validator.required(val, 'Omschrijving')]" label="Omschrijving*" v-model="newTodo.name"></eod-text-field>
                <eod-object-autocomplete class="mt-4" :rules="[val => $validator.required(val.id, 'Team')]" label="Team*" endpoint="groups" v-model="newTodo.responsibleGroup" return-object searchText="Zoek een team..."></eod-object-autocomplete>
                <eod-textarea class="mt-4" label="Extra info" v-model="newTodo.description"></eod-textarea>
            </v-form>
        </eod-dialog>
    </div>
</template>
<script>
import Todo from './../models/todo.js';
import eodObjectAutocomplete from './eod-object-autocomplete.vue';

export default {
    name: 'eod-checklist',
    components: {
        eodObjectAutocomplete
    },
    props: {
        value: Array,
        default: Object,
        filters: Object,
        hideCheckbox: Boolean,
        hideAdd: Boolean,
        hideEdit: Boolean,
        hideDelete: Boolean,
    },
    data: () => ({
        isCreateTodoDialogVisible: false,
        isDeleteTodoDialogVisible: false,
        newTodo: {name:null, responsibleGroup:{name:null}},
        todoToDeleteIndex: null,
        editTodoIndex: null,
        createError: null,
        isCreateLoading: false,
        isDeleteLoading: false,
        isChangeStatusLoading: false,
        items: [],
        updateList: 934302
    }),
    created(){
        if(this.default){
            this.newTodo = {
                ...this.newTodo,
                ...this.default
            }
        }

        this.loadTodos();
    },
    methods: {
        toggleStatus(itemIndex){

            let statusCode = this.items[itemIndex].statusCode == 'done'?null:'done';
            this.isChangeStatusLoading = true;

            this.$eod.save('Task', {
                id: this.items[itemIndex].id,
                statusCode: statusCode
            }).then(response => {
                if(response && response.data.data && response.data.data.updateTask){
                    this.items[itemIndex].statusCode = statusCode;
                    if(this.value){
                        const val = this.value;
                        val[itemIndex].statusCode = statusCode;
                        this.$emit('input', val);
                    }

                    this.updateList++;
                } else {
                    console.error('Invalid response toggle checklist', response);
                }
            }).catch(e => {
                console.error('Error toggle checklist', e);
            }).finally(() => {
                this.isChangeStatusLoading = false;
            });
        },
        showEditTodoDialog(index){
            this.newTodo = Object.assign({}, this.items[index]);

            this.editTodoIndex = index;

            this.isCreateTodoDialogVisible = true;
        },
        loadTodos(){

            if(this.value){
                this.items = this.value;
                return;
            }

            const filters = {
                orderBy:{
                    column: 'name',
                    type: 'asc'
                }
            };
            if(this.default){
                filters.where = [];
                for (const key in this.default) {
                    filters.where.push({
                        column: key,
                        value: this.default[key]
                    });
                }
            }

            if(this.filters){
                filters.where = [];
                for (const key in this.filters) {
                    filters.where.push({
                        column: key,
                        value: this.filters[key]
                    });
                }
            }

            this.$eod.get('tasks', ['id','responsibleGroup{id name}', 'name', 'statusCode', 'description'], filters)
                .then(response => {
                    if(response && response.data.data && response.data.data.tasks){
                        this.items = response.data.data.tasks.edges;
                    } else {
                        console.error('Invalid response for checklist', response);
                    }
                }).catch((e) => {
                    console.error('Error getting checklist', e);
                });
        },
        showDeleteTodoDialog(index){
            this.todoToDeleteIndex = index;

            this.$nextTick(() => {
                this.isDeleteTodoDialogVisible = true;
            });
        },
        showCreateTodoDialog(){
            const defaultTeamId = this.$eod.getOrganizationSetting('checklists.defaultTeamId');

            this.newTodo = {
                name: null,
                description: null,
                responsibleGroup:{id:defaultTeamId.value || null}
            };

            if(this.default){
                this.newTodo = {
                    ...this.newTodo,
                    ...this.default
                }
            }

            this.isCreateTodoDialogVisible = true;
        },
        deleteTodo(){
            const todoToDelete =  this.items[this.todoToDeleteIndex];
            this.isDeleteLoading = true;
            this.$eod.delete('Task', todoToDelete.id).then(response => {
                if(response && response.data.data && response.data.data.deleteTask){
                    this.items.splice(this.todoToDeleteIndex, 1);
                    this.todoToDeleteIndex = null;
                    this.isDeleteTodoDialogVisible = false;
                    this.isDeleteLoading = false;
                } else {
                    console.error('Wrong response deleting checklist', response);
                }
            }).catch(e => {
                console.error('Error deleting checklist', e);
            });
        },
        async addTodo(){
            this.createError = null;
            
            if(this.$refs.createTodoForm && this.$refs.createTodoForm.validate()){
                this.isCreateLoading = true;
                const todo = new Todo(this.newTodo);
                const data = await todo.getSaveData();

                const result = await this.$eod.save('Task', data)
                    .then(response => {
                        if(response && response.data.data && response.data.data.createTask){
                            todo.id = response.data.data.createTask.id;
                            this.items.push(todo);

                            return response.data.data.createTask.id;
                        } else if(response && response.data.data && response.data.data.updateTask){

                            this.items[this.editTodoIndex] = todo;
                            return response.data.data.updateTask.id;
                        } else {
                            console.error('Wrong response saving checklist', response);
                        }

                        return null;
                    }).catch(e => {
                        console.error('Error saving checklist', e);
                        return null;
                    });

                if(result){
                    this.isCreateTodoDialogVisible = false;
                } else {
                    this.createError = 'Er liep iets fout bij het opslaan van het item.';
                }

                this.isCreateLoading = false;
            }
            
        }
    }
}
</script>